import React from 'react';
// eslint-disable-next-line no-unused-vars
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Search, Lock } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * A renderer that takes the JSON schema generated by Gemini 3.5 Flash
 * and dynamically compiles it into React components on the fly.
 */
export default function GenerativeCanvas({ schema }) {
  if (!schema) return null;

  // The engine that parses the AI's JSON into actual React components
  const renderNode = (node, index) => {
    switch (node.type) {
      case 'GenerativeWidget':
        return (
          <motion.div
            key={node.id || index}
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed z-50 pointer-events-auto bg-slate-900/90 backdrop-blur-3xl border border-white/20 p-4 rounded-xl shadow-2xl max-w-[250px]"
            style={{ 
              left: node.position?.x || 0, 
              top: node.position?.y || 0,
              // Keep it within screen bounds
              transform: 'translate(min(0px, calc(100vw - 100% - 20px)), min(0px, calc(100vh - 100% - 20px)))'
            }}
          >
            {node.children && node.children.map((child, i) => renderNode(child, i))}
          </motion.div>
        );

      case 'Text':
        return (
          <p key={index} className={cn('text-white', node.style)}>
            {node.content}
          </p>
        );

      case 'Button':
        return (
          <button
            key={index}
            className="w-full flex items-center justify-center gap-2 py-2 mt-2 bg-edge-coral hover:bg-edge-pink text-white font-black text-[10px] uppercase tracking-widest rounded-lg transition-colors"
            onClick={() => console.log('[Generative UI] Action Triggered:', node.action)}
          >
            {node.action === 'OPEN_SEARCH' && <Search className="w-3 h-3" />}
            {node.action === 'LOCK_VAULT' && <Lock className="w-3 h-3" />}
            {node.label}
          </button>
        );

      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      <div className="pointer-events-none fixed inset-0 z-[100]">
        {renderNode(schema, 'root')}
      </div>
    </AnimatePresence>
  );
}
